namespace $.$$ {

	let $shm_hitalama_entergate_offline_cleanup_promise: Promise< any > | null = null

	const $shm_hitalama_entergate_gate_key_prefix = '$' + 'hitalama_profile_gate.'
	const $shm_hitalama_entergate_access_token_key = $shm_hitalama_entergate_gate_key_prefix + 'access_token'
	const $shm_hitalama_entergate_pending_login_key = $shm_hitalama_entergate_gate_key_prefix + 'pending_login'
	const $shm_hitalama_entergate_worker_reload_key = '$' + 'hitalama_entergate.worker_reload'

	function $shm_hitalama_entergate_offline_cleanup() {
		return $shm_hitalama_entergate_offline_cleanup_promise ??= Promise.all([
			globalThis.navigator?.serviceWorker?.getRegistrations?.().then(
				registrations => Promise.all( registrations.map( registration => registration.unregister() ) ),
			),
			globalThis.caches?.delete?.( '$mol_offline' ),
		]).catch( error => console.warn( error ) )
	}

	function $shm_hitalama_entergate_worker_controlled() {
		return Boolean( globalThis.navigator?.serviceWorker?.controller )
	}

	export class $shm_hitalama_entergate extends $.$shm_hitalama_entergate {

		private offline_cleanup_started = false

		@ $mol_mem
		offline_cleanup() {
			if( this.offline_cleanup_started ) return null
			this.offline_cleanup_started = true

			$shm_hitalama_entergate_offline_cleanup().then( ()=> {
				if( !$shm_hitalama_entergate_worker_controlled() ) {
					sessionStorage.removeItem( $shm_hitalama_entergate_worker_reload_key )
					return
				}

				if( sessionStorage.getItem( $shm_hitalama_entergate_worker_reload_key ) ) return
				sessionStorage.setItem( $shm_hitalama_entergate_worker_reload_key, '1' )
				location.reload()
			} )

			return null
		}

	}

	export class $shm_hitalama_entergate_form extends $.$shm_hitalama_entergate_form {

		mode( next?: string ) {
			if( next !== undefined ) {
				this.message( '' )
				this.$.$mol_state_arg.value( 'auth', next === 'register' ? 'register' : null )
			}
			return this.$.$mol_state_arg.value( 'auth' ) === 'register' ? 'register' : 'enter'
		}

		enter_current() {
			return this.mode() === 'enter'
		}

		register_current() {
			return this.mode() === 'register'
		}

		mode_field() {
			return this.mode() === 'enter' ? [ this.Secret_label() ] : [ this.Login_label() ]
		}

		submit_title() {
			return this.mode() === 'enter' ? 'Войти' : 'Зарегистрироваться'
		}

		submit_enabled() {
			return this.mode() === 'enter' ? this.enter_enabled() : this.register_enabled()
		}

		saved_store() { return this.$.$shm_hitalama_account_local.current() }

		message_display() { return this.message() ? 'flex' : 'none' }

		actions() { return [ this.Submit(), ...this.saved_accounts() ] }

		saved_accounts() {
			return this.enter_current() && this.saved_store().items().length ? [ this.Saved_accounts() ] : []
		}

		saved_rows() { return this.saved_store().items().map( item => this.Saved_account( item.id ) ) }

		saved_title( id: string ) { return this.saved_store().items().find( item => item.id === id )?.name ?? '' }

		@ $mol_action
		saved_enter( id: string, next?: any ) {
			this.message( '' )
			const auth = this.$.$mol_error_fence(
				()=> this.saved_store().auth( id ),
				error => { this.message( error.message ); return null },
			)
			if( !auth ) return
			if( !this.access_apply() ) {
				if( !this.message() ) this.message( 'Введите ключ доступа' )
				return
			}
			this.$.$giper_baza_auth.current( auth )
			this.$.$mol_state_local.value( $shm_hitalama_entergate_pending_login_key, null )
			this.Saved_accounts().showed( false )
			this.saved_redirect()
		}

		saved_redirect() { this.redirect( '/' ) }

		@ $mol_action
		submit( next?: any ) {
			return this.mode() === 'enter' ? this.enter( next ) : this.register( next )
		}

		@ $mol_mem
		access_token( next?: string ): string {
			if( next !== undefined ) {
				this.message( '' )
				return this.$.$mol_state_local.value< string >( $shm_hitalama_entergate_access_token_key, next ) ?? ''
			}
			return this.$.$mol_state_local.value< string >( $shm_hitalama_entergate_access_token_key ) ?? ''
		}

		@ $mol_mem
		secret_key( next?: string ): string {
			if( next !== undefined ) {
				this.message( '' )
				return next
			}
			return ''
		}

		@ $mol_mem
		login( next?: string ): string {
			if( next !== undefined ) {
				this.message( '' )
				return next
			}
			return this.$.$mol_state_local.value< string >( $shm_hitalama_entergate_pending_login_key ) ?? ''
		}

		@ $mol_mem
		message( next?: string ): string {
			return next ?? ''
		}

		enter_enabled() {
			return this.access_token().trim() !== '' && this.secret_key().trim() !== '' && !this.message()
		}

		register_enabled() {
			return this.access_token().trim() !== '' && this.login().trim() !== '' && !this.message()
		}

		@ $mol_action
		enter( next?: any ) {
			if( !this.access_apply() ) return
			const auth = this.auth_from_secret_key()
			if( !auth ) {
				this.message( 'Неверный секретный ключ' )
				return
			}

			this.$.$giper_baza_auth.current( auth )
			this.$.$mol_state_local.value( $shm_hitalama_entergate_pending_login_key, null )
			this.redirect( '/' )
		}

		@ $mol_action
		register( next?: any ) {
			if( !this.access_apply() ) return

			const auth = this.$.$mol_error_fence(
				()=> this.$.$giper_baza_auth.grab(),
				error => this.$.$shm_hitalama_compat_crypto_error( error ),
			)
			this.$.$giper_baza_auth.current( auth )
			this.$.$mol_state_local.value( $shm_hitalama_entergate_pending_login_key, this.login().trim() )
			this.redirect( '/' )
		}

		auth_from_secret_key() {
			const key = this.secret_key().trim()
			if( !key ) return null

			const auth = this.$.$mol_error_fence(
				()=> this.$.$giper_baza_auth.from( key ),
				()=> null,
				()=> null,
			)
			if( auth?.byteLength !== 128 ) return null
			return auth
		}

		access_apply() {
			const token = this.access_token().trim()
			if( !token ) return false

			const response = $mol_wire_sync( this ).access_request( token )

			if( response.ok ) {
				this.$.$mol_state_local.value( $shm_hitalama_entergate_access_token_key, token )
				return true
			}

			this.message( 'Неверный ключ доступа' )
			return false
		}

		access_request( token: string ) {
			const body = new URLSearchParams({ password: token, api: '1' })
			return this.$.$mol_dom_context.fetch( '/login', {
				method: 'POST',
				body,
				credentials: 'same-origin',
				headers: {
					'content-type': 'application/x-www-form-urlencoded;charset=UTF-8',
				},
			} )
		}

		redirect( uri: string ) {
			const next = new URL( location.href ).searchParams.get( 'next' )
			const target = next && next.startsWith( '/' ) && new URL( next, location.origin ).origin === location.origin
				? next
				: uri
			$shm_hitalama_entergate_offline_cleanup().finally( ()=> {
				location.href = target
			} )
		}

	}

}
